import { sdk } from 'sdk';
import useSWR from 'swr';
import { StoreConfiguration } from './types';

const useStoreConfiguration = () => {
  const { data, mutate, ...response } = useSWR(
    ['/action/custom-object/getStoreConfiguration'],
    () =>
      sdk.callAction<StoreConfiguration>({
        actionName: 'custom-object/getStoreConfiguration',
      }),
  );

  const storeConfiguration = data?.isError ? null : data?.data;

  return {
    storeConfiguration,
    isLoading: response.isLoading,
  };
};

export default useStoreConfiguration;
